import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { TextPassage } from '../TextPassage/index.js';
import { StockStatusEnum } from './stockStatusEnum.js';
export const StockStatusLabel = ({ stockStatus, labelSize, labelInStock = 'In stock', labelFewLeftInStock = 'Only a few left', labelOutOfStock = 'Out of stock', labelNotAvailable = 'Not available in your area', className, }) => {
    const labels = {
        [StockStatusEnum.InStock]: labelInStock,
        [StockStatusEnum.FewLeftInStock]: labelFewLeftInStock,
        [StockStatusEnum.OutOfStock]: labelOutOfStock,
        [StockStatusEnum.NotAvailable]: labelNotAvailable,
    };
    const componentClassNames = classNames('sparky-c-stock-status-label', className, {
        'sparky-u-color-utility-success': stockStatus === StockStatusEnum.InStock,
        'sparky-u-color-utility-warning': stockStatus === StockStatusEnum.FewLeftInStock,
        'sparky-u-color-utility-error': stockStatus === StockStatusEnum.OutOfStock ||
            stockStatus === StockStatusEnum.NotAvailable,
    });
    return (_jsx(TextPassage, Object.assign({ className: componentClassNames, size: labelSize }, { children: labels[stockStatus] })));
};
//# sourceMappingURL=StockStatusLabel.js.map